import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import usePWAStatus from '../hooks/usePWAStatus';

const { FiWifi, FiWifiOff } = FiIcons;

const OfflineNotice = () => {
  const { isOffline } = usePWAStatus();

  if (!isOffline) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      className="fixed top-0 left-0 right-0 bg-orange-500 text-white py-2 px-4 flex items-center justify-center z-50"
    >
      <SafeIcon icon={FiWifiOff} className="w-4 h-4 mr-2" />
      <span className="text-sm font-medium">
        You are currently offline. Some features may be limited.
      </span>
    </motion.div>
  );
};

export default OfflineNotice;